import bridge from 'utils/bridge.js';

class FeedbackButtonElement extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  handleClick = (event) => {
    if (event.target.matches('a')) {
      event.preventDefault();
    }

    const { policy, country } = this.dataset;
    bridge.emit('feedback:open', { policy, country });
  };
}

if (!customElements.get('feedback-button')) {
  customElements.define('feedback-button', FeedbackButtonElement);
}

export default FeedbackButtonElement;
